import { j as o } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as l } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import "../../../FeatureFlagProvider-C_WBizLB.js";
import { RadioInput as p } from "../../2-atoms/RadioInput/RadioInput.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function $(s) {
  const {
    groupName: a,
    options: e,
    value: r,
    onChange: i,
    "data-testid": d,
    status: m = "enabled"
  } = s;
  return /* @__PURE__ */ o("div", {
    css: {
      "& > *:not(:last-child)": {
        borderBottom: `1px solid ${l.slate200}`
      }
    },
    children: e.map((t) => /* @__PURE__ */ o(p, {
      ...t,
      groupName: a,
      isSelected: t.value === r,
      status: m ?? t.status,
      onChange: () => i(t.value),
      "data-testid": d
    }, `${a}-${t.value}`))
  });
}
export {
  $ as RadioList
};
